import { Component, OnInit, OnDestroy, HostListener, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.scss']
})
export class AccueilComponent implements OnInit, OnDestroy, AfterViewInit {

  private ngUnsubscribe: Subject<void>; //Permet de grabber tout ce qu'on doit finallement unsubscribe.

  public listeSlides;
  public nbSlides: number;
  public selectedSlide: number;
  public currentLang: string;

  constructor(private route: ActivatedRoute, private elementRef: ElementRef, private renderer: Renderer2,
    private translateService: TranslateService ) {
    this.listeSlides = this.route.snapshot.data.slides;
    this.nbSlides = this.listeSlides.length || 0;
    this.selectedSlide = 0;
    this.currentLang = 'fr';
    this.ngUnsubscribe = new Subject<void>();
  }

  ngOnInit() {
    this.AjouteClassEnLot('[data-animated]', 'animated-out');
    this.AjouteClassEnLot('[data-animated-left]', 'animated-left-out');
    this.AjouteClassEnLot('[data-animated-right]', 'animated-right-out');

    this.currentLang = this.translateService.currentLang;

    this.translateService.onLangChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event: LangChangeEvent) => {
      this.currentLang = event.lang
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }​​​​​​​​
    
  ngAfterViewInit() {
    setTimeout(() => {
        this.renderer.addClass(document.body, 'loaded');
    });
  }

  private AjouteClassEnLot(item, classe) {
    Array.from<HTMLElement>(this.elementRef.nativeElement.querySelectorAll(item)).forEach((userItem)  => {
      userItem.classList.add(classe);
    });
  }

  private getElementOffset(element) {
    const de = document.documentElement;
    const box = element.getBoundingClientRect();
    const top = box.top + window.pageYOffset - de.clientTop;
    const left = box.left + window.pageXOffset - de.clientLeft;
    return { top: top, left: left };
  }

  public onClickNews(event: Event, index: number) {
    this.selectedSlide = index;
    event.preventDefault();
  }

  @HostListener('window:scroll', ['$event'])
  public onItemAnimateScroll(event) {

    const scrollPosition = window.pageYOffset;
    const WindowHeight = window.innerHeight;

    const list = Array.from<HTMLElement>(this.elementRef.nativeElement.querySelectorAll('.animated-out[data-animated]')) as HTMLElement[];
    list.forEach((userItem) => {

      const componentPosition = this.getElementOffset(userItem).top;
      const delay = parseInt(userItem.getAttribute('data-animated'), 10);

      if (scrollPosition + WindowHeight >= componentPosition) {

        if (isNaN(delay) || 0 === delay) {
          userItem.classList.remove('animated-out');
          userItem.classList.add('animated-in');
        } else {
          setTimeout(function () {
            userItem.classList.remove('animated-out');
            userItem.classList.add('animated-in');
          }, delay);
        }
      }
    });

    // tslint:disable-next-line:max-line-length
    const listLeft = Array.from<HTMLElement>(this.elementRef.nativeElement.querySelectorAll('.animated-left-out[data-animated-left]')) as HTMLElement[];
    listLeft.forEach((userItem) => {

      const componentPosition = this.getElementOffset(userItem).top;
      const delay = parseInt(userItem.getAttribute('data-animated-left'), 10);

      if (scrollPosition + WindowHeight >= componentPosition) {

        if (isNaN(delay) || 0 === delay) {
          userItem.classList.remove('animated-left-out');
          userItem.classList.add('animated-left-in');
        } else {
          setTimeout(function () {
            userItem.classList.remove('animated-left-out');
            userItem.classList.add('animated-left-in');
          }, delay);
        }
      }
    });

    // tslint:disable-next-line:max-line-length
    const listRight = Array.from<HTMLElement>(this.elementRef.nativeElement.querySelectorAll('.animated-right-out[data-animated-right]')) as HTMLElement[];
    listRight.forEach((userItem) => {

      const componentPosition = this.getElementOffset(userItem).top;
      const delay = parseInt(userItem.getAttribute('data-animated-right'), 10);

      if (scrollPosition + WindowHeight >= componentPosition) {

        if (isNaN(delay) || 0 === delay) {
          userItem.classList.remove('animated-right-out');
          userItem.classList.add('animated-right-in');
        } else {
          setTimeout(function () {
            userItem.classList.remove('animated-right-out');
            userItem.classList.add('animated-right-in');
          }, delay);
        }
      }
    });
  }

}
